<template>
  <section class="evaluation" aria-label="Öğretmen değerlendirmesi">
    <div v-if="!BookResult" class="evaluation-empty" role="status">
      <span class="empty-icon"><i class="bi bi-chat-square-text" aria-hidden="true"></i></span>
      <h2>Değerlendirme bekleniyor</h2>
      <p>Öğretmenin değerlendirmesini paylaştığında burada görebilirsin.</p>
    </div>
    <template v-else>
      <header class="evaluation-heading"><h2>Beceri değerlendirmesi</h2><p>Öğretmeninin bu derse ait değerlendirmesi.</p></header>
      <dl class="skill-grid">
        <div v-for="skill in skills" :key="skill.label" class="skill-card">
          <dt><span class="skill-icon"><i :class="'bi bi-' + skill.icon" aria-hidden="true"></i></span>{{ skill.label }}</dt>
          <dd :aria-label="skill.label + ': ' + (skill.value === '-' ? 'Değerlendirilmedi' : skill.value.toUpperCase())">{{ skill.value }}</dd>
        </div>
      </dl>
      <section class="feedback-card" aria-labelledby="teacher-note-title">
        <h3 id="teacher-note-title"><i class="bi bi-chat-left-text" aria-hidden="true"></i> Öğretmen notu</h3>
        <div v-if="note && note.trim()" class="teacher-note" v-html="note"></div>
        <p v-else class="muted">Bu ders için ek bir not paylaşılmamış.</p>
      </section>
      <section v-if="inCorrects.length" class="corrections" aria-labelledby="corrections-title">
        <h3 id="corrections-title">Düzeltmeler</h3>
        <p class="muted">İfadelerini doğru kullanımlarıyla karşılaştırabilirsin.</p>
        <div v-for="(item, index) in inCorrects" :key="index" class="correction-row">
          <div class="correction-original"><span class="correction-label"><i class="bi bi-x-circle" aria-hidden="true"></i> Yanlış kullanım</span><p>{{ item.InCorrect }}</p></div>
          <div class="correction-correct"><span class="correction-label"><i class="bi bi-check-circle" aria-hidden="true"></i> Doğru kullanım</span><p>{{ item.Correct }}</p></div>
        </div>
      </section>
    </template>
  </section>
</template>
<script>
import {ResultPuanText} from '@/common/enum-helper';
export default {
    name: "TabResultSubject",
    props: {
        BookResult:{
            type:Object,
            default:null
        }
    },
    components: {},
    data() {return {}},
    computed: {
        skills() {
            return [
                {label: 'Dinleme', icon: 'ear', value: this.listening},
                {label: 'Okuma', icon: 'book', value: this.reading},
                {label: 'Konuşma', icon: 'chat-dots', value: this.speaking},
                {label: 'Kelime bilgisi', icon: 'journal-text', value: this.vocabulary},
                {label: 'Dil bilgisi', icon: 'card-text', value: this.grammar}
            ];
        },
        note(){
            if(this.BookResult!=null){
                return this.BookResult.note;
            }
            return null;
        },
        listening(){
            if(this.BookResult!=null){
                return ResultPuanText(this.BookResult.listening);
            }
            return null;
        },
        reading(){
            if(this.BookResult!=null){
                return ResultPuanText(this.BookResult.reading);
            }
            return null;
        },
        speaking(){
            if(this.BookResult!=null){
                return ResultPuanText(this.BookResult.speaking);
            }
            return null;
        },
        vocabulary(){
            if(this.BookResult!=null){
                return ResultPuanText(this.BookResult.vocabulary);
            }
            return null;
        },
        grammar(){
            if(this.BookResult!=null){
                return ResultPuanText(this.BookResult.grammar);
            }
            return null;
        },
        inCorrects() {
            try {
                const raw = this.BookResult?.inCorrects;
                const items = typeof raw === 'string' ? JSON.parse(raw) : raw;
                return Array.isArray(items) ? items.filter(item => item && (item.InCorrect || item.Correct)) : [];
            } catch { return []; }
        }
    },
    methods: {
    },
    mounted: function () {

    }
};
</script>
    
<style scoped>
.evaluation { color: #334155; }
.evaluation-heading { margin-bottom: 20px; }
h2 { color: #20382d; font-size: 21px; margin: 0 0 8px; }
h3 { color: #20382d; font-size: 17px; margin: 0 0 14px; }
.evaluation-heading p, .muted { color: #64748b; font-size: 14px; line-height: 1.7; margin: 0; }
.skill-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; margin: 0 0 24px; }
.skill-card { padding: 18px; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; }
dt { display: flex; align-items: center; gap: 8px; font-size: 14px; font-weight: 500; color: #526174; }
.skill-icon { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 9px; background: #ecfdf5; color: var(--brand-primary-hover); }
dd { font-size: 28px; font-weight: 700; color: #20382d; text-transform: uppercase; margin: 12px 0 0; }
.feedback-card { padding: 20px; border: 1px solid #e2e8f0; border-radius: 14px; background: #f8fafc; }
h3 i { color: var(--brand-primary-hover); margin-right: 6px; }
.teacher-note { font-size: 16px; line-height: 1.8; overflow-wrap: anywhere; }
.teacher-note :deep(p:last-child) { margin-bottom: 0; }
.teacher-note :deep(img) { max-width: 100%; height: auto; }
.teacher-note :deep(table) { display: block; max-width: 100%; overflow-x: auto; }
.corrections { margin-top: 28px; }
.correction-row { display: grid; grid-template-columns: 1fr 1fr; margin-top: 14px; border: 1px solid #e2e8f0; border-radius: 12px; overflow: hidden; }
.correction-row > div { padding: 16px; min-width: 0; }
.correction-original { background: #fff8f8; }
.correction-correct { background: #f0fdf7; }
.correction-label { display: flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 600; color: #9f303b; margin-bottom: 8px; }
.correction-correct .correction-label { color: var(--brand-primary-hover); }
.correction-row p { margin: 0; font-size: 16px; line-height: 1.7; overflow-wrap: anywhere; }
.evaluation-empty { text-align: center; padding: 40px 20px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 14px; }
.empty-icon { display: inline-flex; align-items: center; justify-content: center; width: 52px; height: 52px; border-radius: 50%; background: #ecfdf5; color: var(--brand-primary-hover); font-size: 23px; margin-bottom: 16px; }
.evaluation-empty p { color: #64748b; line-height: 1.7; margin-bottom: 0; }
@media(max-width: 575px) { .skill-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } .skill-card { padding: 14px; } .correction-row { grid-template-columns: 1fr; } .feedback-card { padding: 16px; } }
</style>